// extracted by mini-css-extract-plugin
module.exports = {"removerSelecao":"selected-item-widget_removerSelecao__3l_MU","content":"selected-item-widget_content__2rxLL"};